import { render, staticRenderFns } from "./StatisticProjectReportsModal.vue?vue&type=template&id=56e0a00c&scoped=true&"
import script from "./StatisticProjectReportsModal.vue?vue&type=script&lang=js&"
export * from "./StatisticProjectReportsModal.vue?vue&type=script&lang=js&"
import style0 from "./StatisticProjectReportsModal.vue?vue&type=style&index=0&id=56e0a00c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e0a00c",
  null
  
)

export default component.exports